import React from 'react';
import ImagingResultForm from '../components/ImagingResultForm';

const ImagingResultFormPage: React.FC = () => <ImagingResultForm />;

export default ImagingResultFormPage;
